module.exports = __webpack_public_path__ + "img/car101.185505a6.png";